export function debounce(
  callback: (event: unknown) => void,
  duration: number
): (event?: unknown) => void {
  let timer: ReturnType<typeof setTimeout>

  return (event?: unknown) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      callback && callback(event)
    }, duration)
  }
}
